import { api } from './base';

import { MutationArg } from 'v2/types';
import { CasinoAbTestModel, CasinoAbTestStatistic } from 'v2/types/AbTestsModels';
import { SWRKeyValue } from 'v2/types/swr';

export const abTestsService = {
  getCasinoAbTests(): Promise<CasinoAbTestModel[]> {
    return api.get('v1/admin/casino-ad-ab-test').json();
  },

  createCasinoAbTest(_key: string, { arg }: MutationArg<Omit<CasinoAbTestModel, 'id'>>): Promise<CasinoAbTestModel> {
    return api.post('v1/admin/casino-ad-ab-test', { json: arg }).json();
  },

  updateCasinoAbTest(
    [_key, testId]: SWRKeyValue,
    { arg }: MutationArg<Omit<CasinoAbTestModel, 'id'>>
  ): Promise<CasinoAbTestModel> {
    return api.put(`v1/admin/casino-ad-ab-test/${testId}`, { json: arg }).json();
  },

  deleteCasinoAbTest([_key, testId]: SWRKeyValue): Promise<CasinoAbTestModel> {
    return api.delete(`v1/admin/casino-ad-ab-test/${testId}`).json();
  },

  getCasinoAbStatistic([_key, testId]: SWRKeyValue): Promise<CasinoAbTestStatistic> {
    return api.get(`v1/admin/casino-ad-ab-test/${testId}/statistic`).json();
  },
};
